'use client';
import { createContext, useContext, useEffect, useState } from 'react';

type DeviceContextType = {
  isMobile: boolean;
};

type DeviceProviderProps = {
  isMobile?: boolean;
  children: React.ReactNode;
};

function detectMobileDevice(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(
    window.navigator.userAgent,
  );
}

export const DeviceContext = createContext<DeviceContextType>({
  isMobile: false,
});

export function DeviceProvider({ isMobile, children }: DeviceProviderProps) {
  const [deviceInfo, setDeviceInfo] = useState<DeviceContextType>({
    isMobile: isMobile ?? false,
  });

  useEffect(() => {
    const syncDeviceInfo = () => {
      setDeviceInfo({ isMobile: detectMobileDevice() });
    };

    syncDeviceInfo();
    window.addEventListener('resize', syncDeviceInfo);

    return () => {
      window.removeEventListener('resize', syncDeviceInfo);
    };
  }, []);

  return (
    <DeviceContext.Provider
      value={{
        isMobile: deviceInfo.isMobile,
      }}
    >
      {children}
    </DeviceContext.Provider>
  );
}

export const useDevice = () => {
  return useContext(DeviceContext);
};
